import { typo } from '@design-system/styles'
import styled from '@emotion/styled'

export const S = {
  Step0: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 690px;
    padding: 48px 32px;
    background-color: var(--White);
    border-radius: var(--Radius-300);
    border: 1px solid var(--Colors-Gray-400);
    box-shadow: 0px 4px 100px 0px rgba(0, 0, 0, 0.05);
    text-align: center;

    .title {
      ${typo.heading02};
      color: var(--Black, #000);
      font-weight: 700;

      span {
        color: var(--Colors-Sky-400);
      }
    }

    .description {
      ${typo.heading03};
      color: var(--Colors-Gray-600);
      font-weight: 500;
    }

    .start-button {
      width: 180px !important;
      font-weight: 400 !important;
      margin-top: 25px;
    }
  `,

  MainStep: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 27px;
    width: 1000px;
    padding: 25px 31px;
    background-color: var(--White);
    border-radius: var(--Radius-300);
    border: 1px solid var(--Colors-Gray-400);
    box-shadow: 0px 4px 100px 0px rgba(0, 0, 0, 0.05);

    .video-wrapper {
      width: 100%;
      height: 400px;
      border-radius: var(--Radius-300);
      overflow: hidden;

      .video {
        width: 100%;
        height: 100%;
        /** contain으로 할지 fill로 할지 나중에 결정 */
        object-fit: cover;
        object-position: top;
      }
    }

    .text-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 12px;

      .title {
        display: flex;
        align-items: center;
        gap: 12px;
        ${typo.heading02};
        color: var(--Colors-Gray-900);
        font-weight: 700;

        span {
          padding: 10px 16px;
          border-radius: var(--Radius-circle, 9999px);
          background: var(--Colors-Indigo-100, #e0e7ff);
          ${typo.body01};
          color: var(--Colors-Indigo-500);
        }
      }

      .description {
        ${typo.heading03};
        color: var(--Colors-Gray-700);
        font-weight: 500;
        text-align: center;
      }
    }

    .button-section {
      display: flex;
      gap: 12px;

      .prev-button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        width: 120px;
        height: 48px;
        padding: 0 12px;
        border-radius: var(--Radius-100);
        border: 1px solid var(--Colors-Gray-400, #e0e0e0);
        background: var(--Colors-Gray-200);
        color: var(--Colors-Gray-900);
        ${typo.body02};
        overflow: hidden;

        @media (hover: hover) {
          &:hover {
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%),
              var(--Colors-Gray-200);

            .arrow-icon {
              animation: bounce-reverse 1s ease-in-out;
            }
          }

          &:active {
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
              var(--Colors-Gray-200);
          }
        }
      }

      .next-button {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        width: 120px;
        height: 48px;
        padding: 0 12px;
        border-radius: var(--Radius-100);
        background: var(--semantic-neutral, #333);
        color: var(--White);
        ${typo.body02};
        overflow: hidden;

        @media (hover: hover) {
          &:hover {
            background: linear-gradient(
                0deg,
                rgba(255, 255, 255, 0.1) 0%,
                rgba(255, 255, 255, 0.1) 100%
              ),
              var(--Colors-Gray-900);

            .arrow-icon {
              animation: bounce 1s ease-in-out;
            }
          }

          &:active {
            background: linear-gradient(
                0deg,
                rgba(255, 255, 255, 0.2) 0%,
                rgba(255, 255, 255, 0.2) 100%
              ),
              var(--Colors-Gray-900);
          }
        }
      }

      @keyframes bounce {
        from,
        20%,
        50%,
        80%,
        to {
          transform: translate3d(0, 0, 0);
        }

        40% {
          transform: translate3d(6px, 0, 0);
        }

        70% {
          transform: translate3d(4px, 0, 0);
        }

        90% {
          transform: translate3d(2px, 0, 0);
        }
      }

      @keyframes bounce-reverse {
        from,
        20%,
        50%,
        80%,
        to {
          transform: translate3d(0, 0, 0);
        }

        40% {
          transform: translate3d(-6px, 0, 0);
        }

        70% {
          transform: translate3d(-4px, 0, 0);
        }

        90% {
          transform: translate3d(-2px, 0, 0);
        }
      }
    }
  `,
}
